/** @jsx jsx */
import { jsx, css, SerializedStyles } from '@emotion/core';
import { Theme, normalText } from 'features/Theme';
import { useSelector } from 'react-redux';
import { selectTenant } from 'state/tenant';

import { useTheme } from 'emotion-theming';

const headerContainer = (theme: Theme): SerializedStyles => {
  const { backgroundColor, textColor } = theme.header;

  const {
    spacing,
    typography: { fontWeightBold },
  } = theme.mui;

  return css`
    ${normalText(theme)}
    background-color: ${backgroundColor};
    color: ${textColor};
    text-align: center;
    text-transform: uppercase;
    padding: ${spacing(1)}px 0;
    font-weight: ${fontWeightBold};
  `;
};

export const Header: React.FC = () => {
  const tenant = useSelector(selectTenant);
  const theme = useTheme<Theme>();

  if (theme.embedded) {
    return null;
  }
  return <div css={headerContainer}>{tenant.name}</div>;
};

export default Header;
